import CustomCard from 'components/card/CustomCard'
import CustomCardHeader from 'components/card/CustomCardHeader'
import CustomButton, { SemiTransparentButton } from 'components/CustomButton'
import CustomModal from 'components/CustomModal'
import { genderType } from 'constants/commons'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createFulfillmentOperator } from 'redux/slices/fulfillmentOperatorSlice'
import AddOperatorForm from './components/addOperatorForm'
import FulfillmentOperatorsList from './components/fullfillmentOperatorsList'

const FulfillmentOperators = () => {
  const dispatch = useDispatch()

  const { operators, loading, processing } = useSelector(
    (state) => state.fulfillmentOperator,
  )

  const [showModal, setShowModal] = useState(false)
  const [activeModalKey, setActiveModalKey] = useState(null)

  const [operator, setOperator] = useState({
    first_name: '',
    last_name: '',
    mobile: '',
    gender: genderType[0].value || 'MALE',
  })

  useEffect(() => {
    if (!loading && !processing) {
      setShowModal(false)
      setOperator({
        first_name: '',
        last_name: '',
        mobile: '',
        gender: genderType[0].value || 'MALE',
      })
    }
  }, [operators, processing, loading])

  const handleOperatorChange = useCallback((key, value) => {
    setOperator((prev) => ({ ...prev, [key]: value }))
  }, [])

  const ModalOptions = useMemo(
    () => ({
      createFulfillmentOperator: {
        title: () => 'Add Operator',
        buttonLabel: 'Add',
        child: () => (
          <AddOperatorForm
            operator={operator}
            handleOperatorChange={handleOperatorChange}
          />
        ),
        onConfirm: () => {
          dispatch(createFulfillmentOperator(operator))
        },
        validate: () => {
          return (
            (operator.first_name || '').trim().length > 1 &&
            (operator.last_name || '').trim().length > 1 &&
            (operator.mobile || '').trim().length === 10
          )
        },
      },
    }),
    [operator, handleOperatorChange],
  )

  const activeModalComponent = ModalOptions[activeModalKey]

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader contentPosition="none">
              <div className="flex items-center justify-between w-ful">
                <h2 className="text-2xl text-white">Fulfillment Operators</h2>
                <SemiTransparentButton
                  onClick={() => {
                    setShowModal(true)
                    setActiveModalKey('createFulfillmentOperator')
                  }}
                >
                  + Add Operator
                </SemiTransparentButton>
              </div>
            </CustomCardHeader>
            <FulfillmentOperatorsList />
          </CustomCard>
        </div>
      </div>

      {showModal && (
        <CustomModal
          loading={processing}
          showModal={showModal}
          setShowModal={() => {
            setShowModal(false)
          }}
          bodyClasses="max-w-xl"
          title={activeModalComponent?.title()}
          children={activeModalComponent?.child()}
          button={
            activeModalComponent &&
            activeModalComponent.hasOwnProperty('onConfirm') ? (
              <CustomButton
                disabled={!activeModalComponent?.validate()}
                onClick={() => {
                  activeModalComponent?.onConfirm({})
                }}
              >
                {activeModalComponent?.buttonLabel}
              </CustomButton>
            ) : null
          }
        />
      )}
    </div>
  )
}

export default FulfillmentOperators
